export default __webpack_public_path__ + "static/media/iconInstitutionEmpty.16e20969.svg";